module.exports = __webpack_public_path__ + "static/media/e3.2317e255.jpg";